import AccountsSelector from './AccountsSelector';

export default AccountsSelector;
